module.exports=function(scope){ return `<!-- Enrolled successfully -->
<!-- faceMap value will return in response for return=faceMap passed in request -->
{
    "data": {
        "glasses": false,
        "faceMapType": 0,
        "ageResult": 4,
        "livenessStatus": 0,
        "enrollmentIdentifier": "testEnrollmentIdentifier",
        "auditTrailVerificationCheck": true,
        "message": "The 3D FaceMap evaluated and Liveness was proven.",
        "isEnrolled": true,
        "isLowQuality": false,
        "tid": "...",
        "auditTrailMatchCheck": true,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The 3D FaceMap evaluated and Liveness was proven."
    }
}

<!-- Enrollment failed because Liveness could not be determined -->
{
    "data": {
        "glasses": false,
        "faceMapType": 0,
        "livenessStatus": 1,
        "enrollmentIdentifier": "testEnrollmentIdentifier",
        "auditTrailVerificationCheck": true,
        "message": "The 3D FaceMap evaluated and Liveness was not proven.  The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps.",
        "isEnrolled": false,
        "isLowQuality": false,
        "tid": "...",
        "auditTrailMatchCheck": false,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The 3D FaceMap evaluated and Liveness was not proven.  The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/enrollment-post.json.tpl